<script type="text/ecmascript-6">
    import DesignerQuestionSelectDoor from "../DesignerQuestionSelectDoor.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionSelectDoor,
            SynsealTileQuestion
        ],
    }
</script>
